import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalRockChart = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Rock Chart"
      gamePath="/userDashboard/game/rock-chart"
      icon="solar:ranking-bold"
      instructions={[
        "Patch your better eye.",
        "Type the letters appearing on the screen using your keyboard."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalRockChart;
